<template>
  <div class="map__inner">
    <div class="formbar formbar_no-margin" id="">
      <div class="formbar__container">
        <div class="formbar__bg">
          <ul class="formbar-fields">
            <li class="formbar-field formbar-field_address">
              <div class="field-input">
                <input
                  class="field-input__inner formbar__input"
                  placeholder="Введите адрес или название отделения"
                  required=""
                  id="address"
                  type="text"
                  v-model="searchODP"
                >
                <!--<svg class="geo-thin-icon" width="21px" height="26px">
                  <use xlink:href="#geo-thin"></use>
                </svg>-->
              </div>
            </li>
            <li class="formbar-field formbar-field_button lupa"><a class="formbar-field__button" href="#" @click="(e) => {
              e.preventDefault();
              searchODPString();
            }"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="map-list">
      <div class="map-list__container point-list__container">
        <div class="map-list__fade"></div>

        <ul class="map-list__items" v-if="foundODP">
          <PointItem
            v-for="odp in odpCollection"
            :key="odp.id"
            :odp="odp"
            :title="title"
            :buildRoute="buildRoute"
            :showList="showList"
            :odpPageQueryString="odpPageQueryString"
          />
        </ul>

        <a class="map-list__button" v-if="foundODP" href="#" @click="(e)=> {
           getPointsMore(e)
         }" ref="showListMore" id="showListMore"
           :style="pager !== null && pager.page !== pager.lastPage ? '' : 'display: none;'"
        >
          Показать ещё
          <span class="loader-img" v-if="loaderList"></span>
        </a>

      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import PointItem from './PointItem.vue';


// console.log(emptyMapJson);
const axios = require('axios');
// eslint-disable-next-line no-undef
const NEW_API_URL = apiUrl;

export default {
  name: 'PointList',
  props: {
    initCityCode: String,
    isOpenOnWeekends: Boolean,
    acquiring: Boolean,
    interRefunds: Boolean,
    receptionLap: Boolean,
    initPointsData: Object,
    showList: Boolean,
    buildRoute: Function,
    enableODPViewPort: Function,
    searchQueryODP: String,
    title: String,
    enableCourier: Function,
    odpPageQueryString: String,
    setOdpSearchQuery: Function,
    selectedCity: Object,
    filterParams: {
      type: String,
      default: 'filter=pip',
    },
  },
  components: {
    PointItem,
  },
  computed: {
    validateSearchODP() {
      return this.searchODP && this.searchODP.trim().length > 2 && !(/[a-z]/i.test(this.searchODP));
    }
  },
  created() {
    // _.debounce — это функция lodash, позволяющая ограничить то,
    // насколько часто может выполняться определённая операция.
    // В данном случае мы ограничиваем частоту обращений к yesno.wtf/api,
    // дожидаясь завершения печати вопроса перед отправкой ajax-запроса.
    // Узнать больше о функции _.debounce (и её родственнице _.throttle),
    // можно в документации: https://lodash.com/docs#debounce
    this.debouncedSearchOdp = _.debounce(this.searchODPString, 500);
    this.debouncedGetPoints = _.debounce(this.getPoints, 500);
  },
  mounted() {
    if (this.selectedCity) {
      this.onCityChange(this.selectedCity);
    }
  },
  methods: {
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    searchODPString() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      const self = this;

      this.setOdpSearchQuery(this.searchODP);
      this.$emit('search', this.searchODP);

      const searchQuery = this.getSearchQuery();
      const queryParams = this.getQueryParams();

      if (this.validateSearchODP) {
        axios.get(`${NEW_API_URL}/odp?cityCode=${self.selectedCity.Code}&select=title,photos,address,id,workTime,fitting,fittingType,courierDelivery,acquiring,receptionLap&perPage=10`
            + `${searchQuery}${queryParams}`)
          .then((resp) => {
            if (resp) {
              this.cancelSource = null;
              if (resp.data && resp.data.odp.length && resp.data.pager) {
                self.foundODP = true;
                self.enableODPViewPort(true);
                self.pager = resp.data.pager;
                self.odpCollection = resp.data.odp.slice(0, 10);
                if (resp.data.pager.nbResults) {
                  self.$parent.$refs.foundPoint.innerHTML = resp.data.pager.nbResults + self.num2str(resp.data.pager.nbResults, [' отделение', ' отделения', ' отделений']);
                }
              } else {
                self.enableODPViewPort(false);
                self.foundODP = false;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.cancelSource = null;
          });
      } else {
        self.foundODP = true;
        self.enableODPViewPort(true);
        if (!this.initOdpCollection.length) {
          this.getPoints(this.selectedCity.Code);
        } else {
          this.odpCollection = this.initOdpCollection.data.odp.slice(0, 10);
          if (this.initOdpCollection.data.pager.nbResults) {
            this.$parent.$refs.foundPoint.innerHTML = this.initOdpCollection.data.pager.nbResults + this.num2str(this.initOdpCollection.data.pager.nbResults, [' отделение', ' отделения', ' отделений']);
          }
        }
      }
    },
    getPoints(code) {
      /*
       * @FIXME: Вместо этого обработчика должен быть единый метод загрузки отделений, вне зависимости от наличия
       * или отсутствия поисковой строки
       */
      if (this.validateSearchODP) {
        this.searchODPString();
        return;
      }

      this.cancelSearch();

      const self = this;
      const searchQuery = this.getSearchQuery();
      const queryParams = this.getQueryParams();

      this.cancelSource = axios.CancelToken.source();

      axios
        .get(`${NEW_API_URL}/odp?cityCode=${code}&select=title,address,id,workTime,fitting,fittingType,`
          + `courierDelivery,acquiring,receptionLap&perPage=10&${queryParams}${searchQuery}`)
        .then((resp) => {
          if (!resp.data || !resp.data.pager) return;
          self.pager = resp.data.pager;
          if (self.showList) {
            if (resp.data.pager.nbResults) {
              self.$parent.$refs.foundPoint.innerHTML = resp.data.pager.nbResults
                + self.num2str(resp.data.pager.nbResults, [' отделение', ' отделения', ' отделений']);
            }
            else {
              self.$parent.$refs.foundPoint.innerHTML = 'Ничего не найдено'
            }
          }
          self.odpCollection = resp.data.odp.slice(0, 10);
          self.initOdpCollection = resp;
        })
        .catch((error) => {
          console.log(error);

          // self.pager = emptyMapJson.data.pager;
          // if(self.showList) {
          //   self.$parent.$refs.foundPoint.innerHTML = emptyMapJson.data.pager.nbResults + this.num2str(emptyMapJson.data.pager.nbResults, [' отделение', ' отделения', ' отделений']);
          // }
          // self.odpCollection = emptyMapJson.data.odp.slice(0,10);
          // self.initOdpCollection = emptyMapJson;
        })
        .finally(() => {
          this.cancelSource = null;
        });
    },
    num2str(n, text_forms) {
      n = Math.abs(n) % 100; const n1 = n % 10;
      if (n > 10 && n < 20) { return text_forms[2]; }
      if (n1 > 1 && n1 < 5) { return text_forms[1]; }
      if (n1 == 1) { return text_forms[0]; }
      return text_forms[2];
    },
    getPointsMore(e) {
      e.preventDefault();
      const self = this;
      if (this.pager.page !== this.pager.lastPage) {
        this.loaderList = true;
        const searchQuery = this.getSearchQuery();
        const queryParams = this.getQueryParams();

        const nextPage = this.pager.page + 1;
        axios.get(`${NEW_API_URL}/odp?cityCode=${this.selectedCity.Code}&select=id,title,fitting,fittingType,acquiring,receptionLap,isOpenOnWeekends,address,workTime&perPage=10&page=${nextPage}${searchQuery}${queryParams}`)
          .then((resp) => {
            self.pager = resp.data.pager;

            if (self.showList) {
              if (resp.data.pager.nbResults) {
                self.$parent.$refs.foundPoint.innerHTML = resp.data.pager.nbResults + self.num2str(resp.data.pager.nbResults, [' отделение', ' отделения', ' отделений']);
              }
            }
            self.odpCollection = self.odpCollection.concat(resp.data.odp);
            self.loaderList = false;
          })
          .catch((error) => {
            self.loaderList = false;
            console.log(error);
          });
      } else {
        this.$refs.showListMore.hide();
      }
    },
    onCityChange(city) {
      this.getPoints(city.Code);
    },
    getQueryParams() {
      const isOpenOnWeekends = this.isOpenOnWeekends ? `&isOpenOnWeekends=${1}` : '';
      const acquiring = this.acquiring ? `&acquiring=${1}` : '';
      const interRefunds = this.interRefunds ? `&interRefunds=${1}` : '';
      const receptionLap = this.receptionLap ? `&receptionLap=${1}` : '';
      return isOpenOnWeekends + acquiring + interRefunds + receptionLap;
    },
    getSearchQuery() {
      if (!this.validateSearchODP) return '';
      return this.searchODP.length ? `&search=${this.searchODP}` : '';
    }
  },
  data() {
    return {
      loaderList: true,
      odpCollection: [],
      pager: null,
      // Сюда записывается поисковая строка, введенная пользователем
      searchODP: '',
      foundODP: true,
      initOdpCollection: [],
    };
  },
  watch: {
    initPointsData: {
      handler() {
        if (this.initPointsData !== null) {
          this.loaderList = false;
          this.pager = this.initPointsData.data.pager;
          if (this.pager.nbResults) {
            this.$parent.$refs.foundPoint.innerHTML = this.pager.nbResults
              + this.num2str(this.pager.nbResults, [' отделение', ' отделения', ' отделений']);
          }
          this.odpCollection = this.initPointsData.data.odp.slice(0, 10);
          this.initOdpCollection = this.initPointsData;
        }
      },
    },
    isOpenOnWeekends: {
      handler() {
        if (this.selectedCity) {
          this.debouncedGetPoints(this.selectedCity.Code);
        }
      },
      deep: true,
    },
    acquiring: {
      handler() {
        if (this.selectedCity) {
          this.debouncedGetPoints(this.selectedCity.Code);
        }
      },
      deep: true,
    },
    interRefunds: {
      handler() {
        if (this.selectedCity) {
          this.debouncedGetPoints(this.selectedCity.Code);
        }
      },
      deep: true,
    },
    receptionLap: {
      handler() {
        if (this.selectedCity) {
          this.debouncedGetPoints(this.selectedCity.Code);
        }
      },
      deep: true,
    },
    showList: {
      handler() {
        if (this.selectedCity && this.selectedCity.Code) {
          this.debouncedGetPoints(this.selectedCity.Code);
        }
        if (this.showList) {
          // this.pager = this.initPointsData.data.pager;
          if (this.pager !== null) {
            if (this.pager.nbResults) {
              this.$parent.$refs.foundPoint.innerHTML = this.pager.nbResults + this.num2str(this.pager.nbResults, [' отделение', ' отделения', ' отделений']);
            }
          } else {
            this.$parent.$refs.foundPoint.innerHTML = 'Ничего не найдено';
            this.enableODPViewPort(true);
          }
        }
      },
    },
    searchQueryODP: {
      handler() {
        if (this.searchQueryODP.length) {
          this.searchODP = decodeURIComponent(this.searchQueryODP);
          this.debouncedSearchOdp();
        }
      },
    },
    searchODP() {
      this.debouncedSearchOdp();
    },
    selectedCity(newVal) {
      if (newVal) {
        this.onCityChange(newVal);
      }
    },
    filterParams: {
      handler(val) {
        if (this.selectedCity && val === 'deliveryLap=1') {
          this.onCityChange(this.selectedCity);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
  .formbar-fields {
    position: relative;

    .formbar-field_button {
      position: absolute;
      right: 0;
      width: 40px;
      background: #ffffff;

      .formbar-field__button {
        width: 24px;
        background: transparent;
        background: url('../../assets/formbar-search.svg')center no-repeat;
        padding: 0;

        @media(max-width: 1050px) {
          top: 0;
          right: 10px;
          background-color: transparent;
        }
      }
    }
  }

  .formbar_no-margin {
    .formbar__bg {
      background: transparent;
      padding: 0;
      border: 1px solid rgba(222, 222, 222, .75);
    }
  }

  .point-list__container {

    @media(max-width: 580px) {
      padding: 0 !important;
    }
  }

  .formbar-field_address {
    padding: 0 !important;
  }

  .formbar-fields {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .lupa {
    @media (max-width: 1050px) {
      top: 10px !important;
    }
  }

</style>
